// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "." + {"53":"18063370","125":"8e33518d","765":"c2bfd85a"}[chunkId] + ".js";
};